export type CameraFailure = "insecure" | "unsupported" | "denied" | "not_found" | "in_use" | "error";

/** Why the camera cannot even be asked for. Browsers only expose it on HTTPS or localhost. */
export function cameraPrecondition(env: {
  isSecureContext: boolean;
  hasMediaDevices: boolean;
}): CameraFailure | null {
  if (!env.isSecureContext) return "insecure";
  if (!env.hasMediaDevices) return "unsupported";
  return null;
}

/** `getUserMedia` rejections, by what the payer can do about them. */
export function classifyCameraError(error: unknown): CameraFailure {
  const name = (error as { name?: unknown } | null)?.name;
  switch (name) {
    case "NotAllowedError":
    case "SecurityError":
      return "denied";
    case "NotFoundError":
    case "OverconstrainedError":
      return "not_found";
    case "NotReadableError":
    case "AbortError":
      return "in_use";
    default:
      return "error";
  }
}
